import { Dispatch, createContext } from 'react'
import { AuthAction, AuthState } from '../reducers/AuthState.reducer'

export const authStatePersistedKeys: Partial<keyof AuthState>[] = ['token']
export const initialAuthState: AuthState = {
  isAuthenticating: true,
}

export const AuthContext = createContext<{
  state: AuthState
  dispatch: Dispatch<AuthAction>
}>({ state: initialAuthState, dispatch: () => {} })
